import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import hasAuthenticatedRole from '../../../utils/AuthFunctions';
import { formatMaterialNumber } from '../../../utils/DateAndNumberFunctions';
import styles from '../styles.module.scss';
import MaterialDetailsCard from './SummaryComponents/materialDetailsCard/MaterialDetailsCard';
import PlantDetailsCard from './SummaryComponents/plantDetailsCard/PlantDetailsCard';

function SummaryElements({ visible, setVisible }) {
  const { plant, material } = useParams();
  const data = useSelector((state) => state.materialDetailsState.material);
  const mrp = useSelector((state) => state.materialDetailsState.mrpSettings);
  const longText = useSelector((state) => state.materialDetailsState.longText);
  const classification = useSelector((state) => state.materialDetailsState.classification);
  const loading = useSelector((state) => state.materialDetailsState.loading);
  const defaultCurrency = useSelector((state) => state.commonState?.userSettings?.DEFAULT_CURRENCY);
  const currencyList = useSelector((state) => state.commonState?.currencyList);
  const userState = useSelector((state) => state.authState.user);
  const [plantData, setPlantData] = useState();
  const [mrpData, setmrpData] = useState();
  const [canViewPrices, setCanViewPrices] = useState(false);
  const [canWriteback, setCanWriteback] = useState(false);

  const getFullText = (plOrd, textID) => {
    const texts = plOrd?.to_MrpLongText?.results?.filter((e) => e?.TextId === textID);
    if (texts?.length) {
      return texts?.reduce((prev, cur) => (cur?.LongText ? prev + cur?.LongText : prev), '');
    }
    return '';
  };

  const addAdditionalData = (initialData) => {
    if (initialData) {
      const updatedPlantData = _.clone(initialData);
      updatedPlantData.POtext = (longText
        && longText?.material === material)
        ? longText[plant]?.PO_text
        : '';
      updatedPlantData.internal_comment = (longText
        && longText?.material === material)
        ? longText[plant]?.internal_comment
        : '';
      updatedPlantData.material_memo = (formatMaterialNumber(mrpData?.MaterialNumber) === material
        && mrpData?.Plant === plant) ? getFullText(mrpData, 'LTXT') : '';
      if (formatMaterialNumber(mrpData?.MaterialNumber) === material && mrpData?.Plant === plant) {
        updatedPlantData.Pl_Ord_Txt = getFullText(mrpData, 'Z901');
        let lastChecked = '-';
        if (mrpData?.LastCheckedDate) {
          const tempDate = new Date(Number.parseInt(mrpData.LastCheckedDate?.replace(/\//g, '')?.replace('Date(', '')?.replace(')', ''), 10));
          if (!Number.isNaN(typeof tempDate?.getFullYear())) {
            const date = tempDate?.getDate() < 10 ? `0${tempDate?.getDate()}` : tempDate?.getDate();
            const month = tempDate?.getMonth() < 9 ? `0${tempDate?.getMonth() + 1}` : tempDate?.getMonth() + 1;
            if (tempDate) lastChecked = `${date}.${month}.${tempDate?.getFullYear()}`;
          }
        }
        updatedPlantData.LastCheckedDate = lastChecked;
      }
      setPlantData(updatedPlantData);
    }
  };

  useEffect(() => {
    const newData = data?.find(
      (entry) => entry?.PLANT_FACILITY_SAP_ID === plant && entry?.MATERIAL_TYPE_SAP_ID === material,
    );
    addAdditionalData(newData);
  }, [data, plant, material, mrpData]);

  useEffect(() => {
    setmrpData(mrp.find(
      (m) => formatMaterialNumber(m.MaterialNumber) === material && m?.Plant === plant,
    ));
  }, [plant, material, mrp]);

  useEffect(() => {
    addAdditionalData(plantData);
  }, [longText, mrpData]);

  useEffect(() => {
    if (classification?.material === material && plantData) {
      plantData.classification = classification;
    }
  }, [classification, plantData]);

  useEffect(() => {
    if (userState?.idTokenClaims?.roles) {
      const roles = userState?.idTokenClaims?.roles;
      const userCanWriteBack = hasAuthenticatedRole(
        roles, process.env.REACT_APP_IOTA_COMMENTER,
      );
      setCanWriteback(userCanWriteBack);
      const userCanViewPrices = hasAuthenticatedRole(
        roles, process.env.REACT_APP_VIEW_PRICES,
      );
      setCanViewPrices(userCanViewPrices);
    }
  }, [userState?.idTokenClaims]);

  return (
    <div className={styles.summaryElements}>
      <div className={styles.summaryContainer}>
        <MaterialDetailsCard
          data={plantData}
          classification={classification}
          loading={loading}
          canViewPrices={canViewPrices}
          canWriteback={canWriteback}
        />
      </div>
      <div className={styles.divider} />
      <div className={styles.plantDetailsContainer}>
        <PlantDetailsCard
          data={plantData}
          visible={visible}
          setVisible={setVisible}
          defaultCurrency={defaultCurrency}
          currencyList={currencyList}
          canViewPrices={canViewPrices}
        />
      </div>
    </div>
  );
}

export default SummaryElements;
